import React, { createContext, useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { PodtracLogo } from "@podtrac/common/components/PodtracLogo";
import UserMenu from "../shared/UserMenu";
import PaidModal from "./PaidModal";
import Toasts from "./Toasts";
import { EditProfileModal } from "../user/EditProfileModal";

export const LayoutContext = createContext();
export const LayoutMainContext = createContext();

export default function Layout({ top, left }) {
    const { accountID } = useParams();
    const { pathname } = useLocation();
    const layoutRef = useRef();
    const mainRef = useRef();

    const [profileOpen, setProfileOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        mainRef.current?.scrollTo(0, 0);
    }, [pathname]);

    /* THIS DOESN'T WORK
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadAccounts);
    });
    if (accountID) {
        dispatch(loadAccount(accountID));
        dispatch(loadShows(accountID));
    }
    if (showID) {
        dispatch(currentShow(showID));
        dispatch(loadShow(showID));
    } else {
        dispatch(currentShow());
    }
    */

    return (
        <LayoutContext.Provider value={layoutRef}>
            <LayoutMainContext.Provider value={mainRef}>
                <div className="layout" ref={layoutRef}>
                    <Toasts />
                    <PaidModal />
                    <Logo />
                    <header>
                        {/*<Routes>*/}
                        {/*    <Route path="../dashboard/profile" element={<h1>PROFILE</h1>} />*/}
                        {/*    <Route path="/dashboard/:accountID/*" element={<TopNav />} />*/}
                        {/*</Routes>*/}
                        {top}
                        <UserMenu editProfile={() => setProfileOpen(true)} />
                    </header>
                    {left}
                    <main ref={mainRef}>
                        <Outlet />
                    </main>
                </div>
                <EditProfileModal isOpen={profileOpen} close={() => setProfileOpen(false)} />
            </LayoutMainContext.Provider>
        </LayoutContext.Provider>
    );
}

function Logo() {
    return (
        <Link to="" className="logo">
            <PodtracLogo />
        </Link>
    );
}
